
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  data: () => ({
    fetching: false as boolean
  }),

  computed: {
    quote () { return this.$store.state.quote }
  },

  methods: {
    send () {
      this.fetching = true

      axios.post(process.env.VUE_APP_BACKEND_URL + '/backend/?send', this.$store.getters.getAllDataAsJson)
        .then(() => {
          alert('Árajánlat igénylés küldése sikeres. Köszönjük érdeklődését, értékesítő kollégánk hamarosan felveszi Önnel a kapcsolatot!')
          this.$emit('reset')
          this.$store.commit('resetAll')
        })
        .catch(error => console.log(error))
        .finally(() => { this.fetching = false })
    }
  }
})
